import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { IngestionCreateForm } from "./components/IngestionCreateForm";

export function NewIngestionPage() {
  return (
    <LqsPage title="New Ingestion">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <IngestionCreateForm />
      </Container>
    </LqsPage>
  );
}
